"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDimensions = exports.getPropDimension = exports.getDimension = void 0;
var getDimension = function (dimension, img) {
    if (!img.current)
        return 0;
    return typeof dimension === 'function' ? dimension(img.current) : dimension;
};
exports.getDimension = getDimension;
var getPropDimension = function (_a) {
    var width = _a.width, height = _a.height, img = _a.img;
    return ({
        width: (0, exports.getDimension)(width, img),
        height: (0, exports.getDimension)(height, img),
    });
};
exports.getPropDimension = getPropDimension;
var getDimensionValues = function (type, _a) {
    var width = _a.width, height = _a.height, img = _a.img, responsive = _a.responsive, parentWidth = _a.parentWidth, natural = _a.natural;
    var _b = (0, exports.getPropDimension)({ width: width, height: height, img: img }), imageWidth = _b.width, imageHeight = _b.height;
    if (img.current) {
        var _c = img.current, naturalWidth = _c.naturalWidth, naturalHeight = _c.naturalHeight, clientWidth = _c.clientWidth, clientHeight = _c.clientHeight;
        if (type === 'width') {
            if (responsive)
                return parentWidth;
            if (natural)
                return naturalWidth;
            if (imageWidth)
                return imageWidth;
            return clientWidth;
        }
        if (type === 'height') {
            if (responsive)
                return clientHeight;
            if (natural)
                return naturalHeight;
            if (imageHeight)
                return imageHeight;
            return clientHeight;
        }
    }
    return 0;
};
var getDimensions = function (props) { return ({
    width: getDimensionValues('width', props),
    height: getDimensionValues('height', props),
}); };
exports.getDimensions = getDimensions;
